import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a1003bd98f39c6fe90bb6784c6bdc0bfdb from "./generated-37421c98-da2d-4805-bd98-4116b62add41.json";

import a136be1b9bf4be624421f555ef86b124cb from "./generated-f520d693-4f0a-47d6-a423-79e390a07159.json";

import ad84a06a2a30fafe2c1985c7d24b5b048b from "./generated-844aa5bb-b78e-4f81-95d8-a975b885aa32.json";

import a745b24f4cda12905c7e17d1e75e948beb from "./generated-ac8a2589-b5ff-4b7d-986d-d23a477c0d1f.json";

import af0513ca2d8f4d08a9c71843e71dceb85b from "./generated-bb2b384d-1d13-4a0e-8959-ee08221ef553.json";

import a9d40075a3e08375f334a4ada42ba77c3b from "./generated-2d842f23-2feb-4959-b314-6dfb98bd3407.json";

import a5c3b51d5c9ae637752a0d0f623174ed2b from "./generated-6aaafa53-a68d-4eb3-a2a8-17855e75be83.json";

import a6b53e9e0d15cc1796d9c4c585312c59eb from "./generated-6b32f6c7-4bc3-49d8-b26c-dcc012106223.json";

import ab5cb8f14890627f5ddb6b1c038282c7cb from "./generated-76179569-f5eb-4701-b32f-3c1b7eb53ad5.json";

import ab0c0217d2b7a6f688e66884bf89e59eeb from "./generated-1dd3e11a-deac-4950-a6b5-b740db2bf045.json";

import ae0747c27c0ef8d045601a15d2e487b06b from "./generated-0b759caf-3a99-4e70-ad3b-162c9126be0f.json";

import a8f7e343e2b59a4af28b867e82320b9fab from "./generated-472a2163-0f62-48e6-b80b-a71a0338ca37.json";

import a642565c61f675093d644e1196a3ac48fb from "./generated-0dfd7c45-fcb5-4d90-b347-90070764c910.json";

import aa635f146a59d52d51a70affe6ac5a172b from "./generated-3d344fef-8e2a-4f9a-b70f-42c82b920bc1.json";

import aca1ab33ff41475b3c72e051dea2310f7b from "./generated-5e4c4357-3fa4-4dfe-abcf-69989d88d086.json";

import aa52009fed7ecfe36864a3d507a260d50b from "./generated-40656a19-7892-462e-97bd-f236a4f92260.json";

import a669688a88473d7c125aeeea158ebe81db from "./generated-7a58b312-85f1-4583-9a5a-a193bd403b3c.json";

import a9b8834553e3eb16ff7942fdb151a3fd2b from "./generated-42f86337-7534-45c1-895b-caa6f8c87c33.json";

import a98995c712a96116fed5daaffd7ecc9d1b from "./generated-60ef31e3-627d-4b72-8ecf-3f0bae8bbcd7.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a1003bd98f39c6fe90bb6784c6bdc0bfdb);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a136be1b9bf4be624421f555ef86b124cb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(ad84a06a2a30fafe2c1985c7d24b5b048b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a745b24f4cda12905c7e17d1e75e948beb);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(af0513ca2d8f4d08a9c71843e71dceb85b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a9d40075a3e08375f334a4ada42ba77c3b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a5c3b51d5c9ae637752a0d0f623174ed2b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a6b53e9e0d15cc1796d9c4c585312c59eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(ab5cb8f14890627f5ddb6b1c038282c7cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(ab0c0217d2b7a6f688e66884bf89e59eeb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(ae0747c27c0ef8d045601a15d2e487b06b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a8f7e343e2b59a4af28b867e82320b9fab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a642565c61f675093d644e1196a3ac48fb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(aa635f146a59d52d51a70affe6ac5a172b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(aca1ab33ff41475b3c72e051dea2310f7b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(aa52009fed7ecfe36864a3d507a260d50b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a669688a88473d7c125aeeea158ebe81db);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a9b8834553e3eb16ff7942fdb151a3fd2b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a98995c712a96116fed5daaffd7ecc9d1b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a669688a88473d7c125aeeea158ebe81db);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */